import { get } from '../../utils/http';

export const fetchAccountAnalyticsBookedUnique = ({ accountId }) =>
  get(`/accounts/${accountId}/dashboard/analytics/bookedUnique`);

export const fetchAccountAnalyticsBookedVsNeeded = ({ accountId }) =>
  get(`/accounts/${accountId}/dashboard/analytics/bookedVsNeeded`);

export const fetchAccountAnalyticsFulfillment = ({ accountId }) =>
  get(`/accounts/${accountId}/dashboard/analytics/fulfillment`);

export const fetchProfitAndLossAnalytics = ({ accountId, from, to }) =>
  get(`/accounts/${accountId}/dashboard/analytics/profitAndLoss`, { from, to });

export const fetchAccountTotalTimesheetsHours = ({ accountId }) =>
  get(`/accounts/${accountId}/dashboard/analytics/totalTimesheetsHours`);
